module.exports = __webpack_public_path__ + "img/sLightnWmn_350x350.acc3fff8.jpg";